import { SelectNewIntegrationTypeCard } from '@modules/integrationsV2/components/SelectNewIntegrationTypeDrawer';
import { Stack } from '@mui/material';
import {
  IntegrationFormDataViewFragment,
  IntegrationType,
} from 'generated/graphql';

interface SelectNewIntegrationTypeDrawerContentProps {
  integrationFormData: IntegrationFormDataViewFragment[];
}

export const SelectNewIntegrationTypeDrawerContent = ({
  integrationFormData,
}: SelectNewIntegrationTypeDrawerContentProps) => {
  return (
    <Stack spacing={4} p={4}>
      <SelectNewIntegrationTypeCard
        integrationType={IntegrationType.Feedback}
        integrationFormData={integrationFormData}
      />
      <SelectNewIntegrationTypeCard
        integrationType={IntegrationType.User}
        integrationFormData={integrationFormData}
      />
      <SelectNewIntegrationTypeCard
        integrationType={IntegrationType.Account}
        integrationFormData={integrationFormData}
      />
    </Stack>
  );
};
